import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { push } from "store/actions/router";
import { fetchOwners } from "actions/employerActions";

import OwnerFullInfoForm from "pages/signUp/employer/OwnerFullInfoForm";
import IconSpinner from "components/IconSpinner";
import type { GetBeneficialOwnersQuery } from "types/graphql";

interface OwnProps {
  planCode?: string;
}

const mapDispatchToProps = {
  fetchOwners,
  push,
};

const connector = connect(null, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

interface State {
  fetchingOwners: boolean;
  owners: GetBeneficialOwnersQuery["getBeneficialOwners"];
}

class EmployerSelfServeController extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      fetchingOwners: true,
      owners: [],
    };
  }

  async componentDidMount() {
    const { data: owners } = (await this.props.fetchOwners(
      this.props.client as ApolloClient<object>
    )) as { data: State["owners"] };

    this.setState({ fetchingOwners: false, owners });
  }

  render() {
    if (this.state.fetchingOwners) return <IconSpinner centered />;

    return (
      <OwnerFullInfoForm
        // @ts-expect-error OwnerFullInfoForm's owner prop is typed narrower
        // ({ memberProfile?: object }) than the GetBeneficialOwners Member shape
        // (and excludes null); runtime value is the real Member object.
        owner={this.state.owners![0]}
      />
    );
  }
}

export default connector(withApollo<Props>(EmployerSelfServeController));
